import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import {
  useContextQuery,
} from '@modules/core/services/query';

import type {
  IAffiliatesUnconfirmedGetTokenResponse,
} from '../types';
import {
  AFFILIATES_UNCONFIRMED_GET_TOKEN_QUERY_KEY,
  AFFILIATES_UNCONFIRMED_GET_TOKEN_URL,
  AFFILIATES_UNCONFIRMED_PERMISSIONS,
} from '../constants';

export default function useAffiliatesUnconfirmedGetTokenQuery(
  id: Ref<number | undefined>,
): IContextQueryResult<
    IAffiliatesUnconfirmedGetTokenResponse,
    Error,
    string
  > {
  const { fetchGet } = useRestClient();

  return useContextQuery<IAffiliatesUnconfirmedGetTokenResponse, Error, string>({
    queryKey: [AFFILIATES_UNCONFIRMED_GET_TOKEN_QUERY_KEY, id],
    queryFn: () => fetchGet<IAffiliatesUnconfirmedGetTokenResponse>(AFFILIATES_UNCONFIRMED_GET_TOKEN_URL, {
      urlParams: {
        id: id.value,
      },
      permission: AFFILIATES_UNCONFIRMED_PERMISSIONS.SHOW,
    }),
    staleTime: 5000,
    select: (res) => res.token,
    enabled: computed(() => !!id.value),
  });
}
